// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';

export const GET_HISTORYSTATUS = 'GET_HISTORYSTATUS';
export const CREATE_HISTORYSTATUS = 'CREATE_HISTORYSTATUS';
export const DELETE_HISTORYSTATUS = 'DELETE_HISTORYSTATUS';
